import {colors} from './colors';

export type BrandKey = 'ark' | 'cortile';

export type Brand = {
  key: BrandKey;
  name: string;
  aiName: string;
  supportEmail: string;
  supportContactName: string;
  accent: string;
};

export const brands: Record<BrandKey, Brand> = {
  ark: {
    key: 'ark',
    name: 'Ark',
    aiName: 'Ark AI',
    supportEmail: 'noah@projectark.co.uk',
    supportContactName: 'Noah',
    accent: colors.brick,
  },
  cortile: {
    key: 'cortile',
    name: 'Cortile',
    aiName: 'Cortile AI',
    supportEmail: 'cora@cortile.com',
    supportContactName: 'Cora',
    accent: colors.terracotta,
  },
};
